import { Token } from '../interfaces';

const tokenTickerToTokenNameMap = new Map<Token, string>();
tokenTickerToTokenNameMap.set('WBTC', 'Wrapped BTC');
tokenTickerToTokenNameMap.set('ETH', 'Ethereum');
tokenTickerToTokenNameMap.set('DAI', 'DAI Stablecoin');
tokenTickerToTokenNameMap.set('DAIv0', 'DAI Stablecoin V0');
tokenTickerToTokenNameMap.set('USDC.e', 'Bridged USD Coin');
tokenTickerToTokenNameMap.set('USDT', 'Tether USD');
tokenTickerToTokenNameMap.set('LORDS', 'Lords');
tokenTickerToTokenNameMap.set('wstETH', 'Legacy wstETH');
tokenTickerToTokenNameMap.set('NSTR', 'Nostra');
tokenTickerToTokenNameMap.set('STRK', 'Starknet');
tokenTickerToTokenNameMap.set('xSTRK', 'Endur xSTRK');
tokenTickerToTokenNameMap.set('sSTRK', 'Staked Starknet Token');
tokenTickerToTokenNameMap.set('nstSTRK', 'Nostra Staked STRK');
tokenTickerToTokenNameMap.set('UNO', 'UNO Stablecoin');
tokenTickerToTokenNameMap.set('EKUBO', 'Ekubo Protocol');

export function getTokenName(token: Token): string | undefined {
  return tokenTickerToTokenNameMap.get(token);
}
